<div class="datnek-ds-dialog-body dialog-status-paiement">
  <div class="img m-auto">
    <img src="assets/Img/icons/success.svg" alt="" />
  </div>
  <div class="text-center mt-3">Votre paiement a bien été effectué</div>
</div>
